import { Outlet } from 'react-router-dom';

const CallbackRootLayout = () => {
  return (
    <div className="flex h-[100dvh] flex-col">
      <div className="flex flex-1">
        <div className="flex h-full w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CallbackRootLayout;
